import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>
          Ayodhya Estate: <span>Your Gateway to Divine Living.</span>
        </h1>
        <p>Presenting Panchi Vihar – A prestigious land development in the heart of the holy city.</p>
      </div>
    </section>
  );
};

export default Hero;
